import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";

import { PM_CONFERENCES_PATH } from "../../../constants/router";

export const headRows = translate => [
  { id: "name", numeric: false, disablePadding: true, label: translate.name },
  { id: "product", numeric: false, disablePadding: false, label: translate.product },
  { id: "hostPasscode", numeric: false, disablePadding: false, label: translate.hostPasscode },
  { id: "guestPasscode", numeric: false, disablePadding: false, label: translate.guestPasscode },
  { id: "lastUsed", numeric: false, disablePadding: false, label: translate.lastUsed },
  { id: "active", numeric: true, disablePadding: false, label: translate.active },
  { id: "oneTime", numeric: true, disablePadding: false, label: translate.oneTime },
];

export const prepareRowData = conferences => {
  return conferences
    ? conferences.map(conference => {
        const row = {
          ...conference,
          name: conference.conferenceName,
        };
        delete row.conferenceName;
        return row;
      })
    : [];
};

const useStyles = makeStyles(theme => ({
  actions: {
    minWidth: "110px",
  },
  edit: {
    margin: theme.spacing(0, 1),
    maxHeight: "48px",
  },
  checkIcon: {
    color: "green",
  },
  closeIcon: {
    color: "red",
  },
}));

const PMConferenceTableRow = ({ row, isItemSelected, labelId, handleClick }) => {
  const classes = useStyles();
  return (
    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} selected={isItemSelected}>
      <TableCell className={classes.actions} padding="checkbox">
        <Checkbox
          onClick={event => handleClick(event, row.selectIndex)}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
        <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PM_CONFERENCES_PATH}/${row.conferenceId}`}>
          <IconButton className={classes.edit}>
            <EditIcon />
          </IconButton>
        </NavLink>
      </TableCell>
      <TableCell /* component="th" */ id={labelId} scope="row" padding="none">
        {row.name}
      </TableCell>
      <TableCell align="left">{row.product}</TableCell>
      <TableCell align="left">{row.hostPasscode}</TableCell>
      <TableCell align="left">{row.guestPasscode}</TableCell>
      <TableCell align="left">{new Date(row.lastUsed).toDateString()}</TableCell>
      <TableCell align="right">
        {row.active ? <CheckIcon className={classes.checkIcon} /> : <CloseIcon className={classes.closeIcon} />}
      </TableCell>
      <TableCell align="right">
        {row.oneTime ? <CheckIcon className={classes.checkIcon} /> : <CloseIcon className={classes.closeIcon} />}
      </TableCell>
    </TableRow>
  );
};

PMConferenceTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default PMConferenceTableRow;
